function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.array.some.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import RequirementQuestionStatus from "./RequirementQuestionStatus";
import FileListing from "./FileListing";
import { Box, Table, TableBody, TableCell, TableRow, TableHead, Collapse, Chip, Button, Typography, icons, useId, useMediaQuery } from '@applyboard/ui-components';
import { Link } from '@applyboard/ab-common';
import { SECONDARY_BACKGROUND } from "../../../../components/style/colors";
import orderBy from 'lodash/orderBy';
import { getCorrectURL } from "../../../../util/isAbsolutePath";
import useInitialProps from "../../../../hooks/useInitialProps";
import { formatFileName } from "./utils";
import { useEventTracker } from '@applyboard/ui-utils';
var ErrorOutlineIcon = icons.ErrorOutlineIcon,
  ArrowChevronDown = icons.ArrowChevronDown,
  ArrowChevronUp = icons.ArrowChevronUp,
  Edit = icons.Edit;
var RequirementCardBottomBar = function RequirementCardBottomBar(_ref) {
  var _requirement$applicat, _requirement$attachme;
  var requirement = _ref.requirement,
    preview = _ref.preview,
    onClickOverride = _ref.onClickOverride,
    onToggleQuestionsModal = _ref.onToggleQuestionsModal,
    reloadAggregatedData = _ref.reloadAggregatedData,
    programId = _ref.programId,
    schoolGroupId = _ref.schoolGroupId,
    RemoveFileDialog = _ref.RemoveFileDialog,
    HybridRequirementDecisionReasons = _ref.HybridRequirementDecisionReasons,
    aggregatedDataRequirements = _ref.aggregatedDataRequirements;
  var initialProps = useInitialProps();
  var showRequirementQuestionStatus = requirement.requirement_template_type === 'questions';
  var showFileListing = requirement.requirement_template_type === 'document' || requirement.requirement_template_type === 'receipt';
  var showPaymentRequirement = requirement.requirement_template_type === 'payment';
  var isApplyproofPolling = initialProps === null || initialProps === void 0 ? void 0 : initialProps.is_applyproof_polling;
  var isNarrowLayout = useMediaQuery('(max-width: 1380px)') || preview;
  var _useEventTracker = useEventTracker({
      data: {
        requirementType: requirement.requirement_template_type,
        requirementStatus: requirement.status,
        userRole: initialProps.role
      }
    }),
    trackEvent = _useEventTracker.trackEvent,
    Track = _useEventTracker.Track;
  var questionsWithNumber = (_requirement$applicat = requirement.application_questions) === null || _requirement$applicat === void 0 ? void 0 : _requirement$applicat.map(function (question, idx) {
    return _objectSpread(_objectSpread({}, question), {}, {
      questionNum: idx + 1
    });
  });
  var rejectedQuestions = getRejectedOrUnapprovedReAttemptedQuestions(questionsWithNumber);
  var rejectedFiles = ((_requirement$attachme = requirement.attachments) === null || _requirement$attachme === void 0 ? void 0 : _requirement$attachme.filter(function (file) {
    return (file === null || file === void 0 ? void 0 : file.status) === 'disapproved';
  })) || [];
  var aggregatedDataRequirement = aggregatedDataRequirements === null || aggregatedDataRequirements === void 0 ? void 0 : aggregatedDataRequirements.find(function (aggregatedDataRequirement) {
    return requirement.id.toString() === aggregatedDataRequirement.id;
  });
  var anyRejectedReqAttachment = rejectedFiles.length > 0 || rejectedQuestions.length > 0 || !!(aggregatedDataRequirement !== null && aggregatedDataRequirement !== void 0 && aggregatedDataRequirement.decisionReasons.length);
  var showRejectionListByDefault = requirement.status !== 'status_completed' && requirement.required_state !== 'required_state_inactive' && anyRejectedReqAttachment;
  var _useState = useState(showRejectionListByDefault),
    _useState2 = _slicedToArray(_useState, 2),
    shouldShowRejectionList = _useState2[0],
    setShouldShowRejectionList = _useState2[1];
  var toggleShouldShowRejectionList = function toggleShouldShowRejectionList() {
    return setShouldShowRejectionList(!shouldShowRejectionList);
  };
  var collapsibleSectionId = useId();
  useEffect(function () {
    if (showRejectionListByDefault) {
      setShouldShowRejectionList(true);
    }
  }, []);
  return /*#__PURE__*/React.createElement(Track, null, /*#__PURE__*/React.createElement("div", {
    style: {
      width: '100%'
    }
  }, /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    alignItems: isNarrowLayout ? 'flex-start' : 'center',
    flexDirection: isNarrowLayout ? 'column' : 'row',
    justifyContent: isNarrowLayout ? 'flex-start' : 'space-between',
    pl: 2,
    pr: 2,
    pt: 0.5,
    pb: 0.5,
    style: {
      backgroundColor: SECONDARY_BACKGROUND,
      width: '100%'
    }
  }, /*#__PURE__*/React.createElement("div", null, showRequirementQuestionStatus && /*#__PURE__*/React.createElement(RequirementQuestionStatus, {
    requirement: requirement,
    rejectedQuestions: rejectedQuestions,
    layout: isNarrowLayout ? 'vertical' : 'horizontal',
    onToggleQuestionsModal: onToggleQuestionsModal
  }), showPaymentRequirement && /*#__PURE__*/React.createElement(Typography, {
    style: {
      fontWeight: 600
    }
  }, requirement.status === 'status_completed' ?
  /*#__PURE__*/
  // @ts-expect-error TODO
  React.createElement(Link, {
    to: "/orders/".concat(requirement.order_id, "/receipt")
  }, "View payment receipt") : /*#__PURE__*/React.createElement(React.Fragment, null, "0 payments recorded")), showFileListing && /*#__PURE__*/React.createElement(FileListing, {
    requirement: requirement,
    preview: preview,
    onClickOverride: onClickOverride,
    isApplyproofPolling: isApplyproofPolling,
    layout: isNarrowLayout ? 'vertical' : 'horizontal',
    reloadAggregatedData: reloadAggregatedData,
    programId: programId,
    schoolGroupId: schoolGroupId,
    RemoveFileDialog: RemoveFileDialog
  }), requirement.requirement_template_type === 'hybrid' && /*#__PURE__*/React.createElement(Typography, {
    style: {
      fontWeight: 600
    }
  }, requirement.status === 'status_completed' || requirement.status === 'status_reviewing' || requirement.status === 'status_not_approved' ? /*#__PURE__*/React.createElement(React.Fragment, null, "Response received.") : /*#__PURE__*/React.createElement(React.Fragment, null, "No response received."))), anyRejectedReqAttachment && !preview && /*#__PURE__*/React.createElement(Button, {
    color: "primary",
    variant: "text",
    onClick: function onClick() {
      trackEvent({
        event: "Single Application - Applicant Requirements - Clicked ".concat(shouldShowRejectionList ? 'Hide Rejections' : 'See Rejections')
      });
      toggleShouldShowRejectionList();
    },
    disableFocusRipple: false,
    disableRipple: false,
    startIcon: shouldShowRejectionList ? /*#__PURE__*/React.createElement(ArrowChevronUp, null) : /*#__PURE__*/React.createElement(ArrowChevronDown, null),
    "aria-expanded": shouldShowRejectionList,
    "aria-controls": collapsibleSectionId,
    style: {
      whiteSpace: 'nowrap',
      flexShrink: 0
    },
    mt: isNarrowLayout ? 1 : 0
  }, getToggleButtonText({
    shouldShowRejectionList: shouldShowRejectionList,
    requirement: requirement
  }))), anyRejectedReqAttachment && /*#__PURE__*/React.createElement(RejectionListSection, {
    id: collapsibleSectionId,
    expanded: shouldShowRejectionList && !preview,
    requirement: requirement,
    rejectedQuestions: rejectedQuestions,
    rejectedFiles: rejectedFiles,
    onToggleQuestionsModal: onToggleQuestionsModal,
    HybridRequirementDecisionReasons: HybridRequirementDecisionReasons,
    aggregatedDataRequirement: aggregatedDataRequirement
  })));
};
var RejectionListSection = function RejectionListSection(_ref2) {
  var _aggregatedDataRequir;
  var id = _ref2.id,
    expanded = _ref2.expanded,
    rejectedQuestions = _ref2.rejectedQuestions,
    rejectedFiles = _ref2.rejectedFiles,
    requirement = _ref2.requirement,
    onToggleQuestionsModal = _ref2.onToggleQuestionsModal,
    HybridRequirementDecisionReasons = _ref2.HybridRequirementDecisionReasons,
    aggregatedDataRequirement = _ref2.aggregatedDataRequirement;
  var rejectedFilesSorted = requirement.requirement_template_type !== 'hybrid' ? orderBy(rejectedFiles, ['updated_at'], ['desc']) : [];
  var showReAttemptQuestions = requirement.requirement_template_type === 'questions' && rejectedQuestions.some(function (question) {
    return question.status === 'disapproved';
  }) && requirement.status !== 'status_completed';
  return /*#__PURE__*/React.createElement(Collapse, {
    "in": expanded,
    id: id,
    role: "region",
    "aria-label": "Rejection Reasons",
    mountOnEnter: true,
    unmountOnExit: true
  }, /*#__PURE__*/React.createElement(Box, {
    p: 2
  }, /*#__PURE__*/React.createElement(Table, {
    stickyHeader: requirement.requirement_template_type !== 'hybrid'
  }, /*#__PURE__*/React.createElement(TableHead, null, /*#__PURE__*/React.createElement(TableRow, null, requirement.requirement_template_type !== 'hybrid' && /*#__PURE__*/React.createElement(TableCell, null, requirement.requirement_template_type === 'questions' ? 'Question' : 'Document'), /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center"
  }, /*#__PURE__*/React.createElement("div", null, "Rejection Reason"), showReAttemptQuestions && /*#__PURE__*/React.createElement(Button, {
    mr: 0.5,
    startIcon: /*#__PURE__*/React.createElement(Edit, {
      variant: "fill"
    }),
    onClick: onToggleQuestionsModal
  }, "Reattempt Questions"))))), /*#__PURE__*/React.createElement(TableBody, null, (aggregatedDataRequirement === null || aggregatedDataRequirement === void 0 ? void 0 : (_aggregatedDataRequir = aggregatedDataRequirement.decisionReasons) === null || _aggregatedDataRequir === void 0 ? void 0 : _aggregatedDataRequir.length) && /*#__PURE__*/React.createElement(TableRow, null, /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement(HybridRequirementDecisionReasons, {
    requirementId: aggregatedDataRequirement.id
  }))), rejectedFilesSorted.map(function (file) {
    return /*#__PURE__*/React.createElement(TableRow, {
      key: file.id
    }, /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement(Chip, {
      icon: /*#__PURE__*/React.createElement(ErrorOutlineIcon, null),
      color: "negative",
      label: formatFileName(file.fileName),
      href: getCorrectURL(file.fileDownloadLink),
      role: "link",
      target: "_blank",
      rel: "noopener",
      component: "a",
      clickable: true
    })), /*#__PURE__*/React.createElement(TableCell, null, file.statusNote));
  }), rejectedQuestions.map(function (question) {
    var answers = getRejectedAnswersWithAnswerNum(question);
    return (
      /*#__PURE__*/
      // eslint-disable-next-line react/jsx-key
      React.createElement(TableRow, null, /*#__PURE__*/React.createElement(TableCell, null, question.questionNum), /*#__PURE__*/React.createElement(TableCell, null, answers.length === 1 && /*#__PURE__*/React.createElement("div", null, answers[0].status_note), answers.length > 1 && answers.map(function (answer) {
        return (
          /*#__PURE__*/
          // eslint-disable-next-line react/jsx-key
          React.createElement("div", null, "Attempt ", answer.num, ": ", answer.status_note)
        );
      })))
    );
  })))));
};
var getToggleButtonText = function getToggleButtonText(params) {
  if (params.requirement.status === 'status_completed') {
    return params.shouldShowRejectionList ? 'Hide History' : 'See History';
  }
  return params.shouldShowRejectionList ? 'Hide Rejections' : 'See Rejections';
};
var getRejectedAnswersWithAnswerNum = function getRejectedAnswersWithAnswerNum(question) {
  var answers = question.answers || [];
  var answerRows = answers.map(function (answer, idx) {
    return {
      status_note: answer.status_note,
      status: answer.status,
      num: idx + 1
    };
  }).filter(function (answerRow) {
    return answerRow.status === 'disapproved';
  });
  return answerRows;
};
var getRejectedOrUnapprovedReAttemptedQuestions = function getRejectedOrUnapprovedReAttemptedQuestions(questions) {
  if (!questions) {
    return [];
  }
  return questions.filter(function (question) {
    var _question$answers;
    if (question.status === 'disapproved') {
      return true;
    }
    if (question.status === 'approved') {
      return false;
    }
    return (_question$answers = question.answers) === null || _question$answers === void 0 ? void 0 : _question$answers.some(function (answer) {
      return answer.status === 'disapproved';
    });
  });
};
export default RequirementCardBottomBar;